import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SeasonMetaDataCombinedModel } from '../models/season-models/season-meta-data-combined-model';
import { SeasonsStatusModel } from '../models/season-models/seasons-status-model';
import { SeasonCropModel } from '../models/season-models/season-crop-model';
import { SeasonFertilizerPlacementModel } from '../models/season-models/season-fertilizer-placement';
import { SeasonFertilizerPlacementWithPlantingModel } from '../models/season-models/season-fertilizer-placement-with-planting-model';
import { SeasonFertilizerTypeModel } from '../models/season-models/season-fertilizer-type-model';
import { SeasonTypeModel } from '../models/season-models/season-field-type-model';
import { SeasonHarvestResiduesModel } from '../models/season-models/season-harvest-residues-model';
import { SeasonIrrigationTypeModel } from '../models/season-models/season-irrigation-type-model';
import { SeasonMethodOfTopDressingModel } from '../models/season-models/season-method-of-top-dressing-model';
import { SeasonPlantActionModel } from '../models/season-models/season-plant-action-model';
import { SeasonPlantFertilizerTypeModel } from '../models/season-models/season-plant-fertilizer-type-model';
import { SeasonPodEffectivenessModel } from '../models/season-models/season-pod-effectiveness-model';
import { SeasonTillageModel } from '../models/season-models/season-tillage-model';
import { SeasonTopDressingMethodModel } from '../models/season-models/season-top-dressing-method-model';
import { SeasonTypeOfFertilizerBobModel } from '../models/season-models/season-type-of-fertilizer-bob-model';
import { SeasonTypeOfTopDressingFertilizer } from '../models/season-models/season-type-of-top-dressing-fertilizer-model';
import { SeasonWaterQualityEcModel } from '../models/season-models/season-water-quality-ec-model';
import { SeasonFarmsModel } from '../models/season-models/season-farms-model';
import { SeasonFieldsModel } from '../models/season-models/season-fields-model';
import { SeasonFieldPlantSpreadModel } from '../models/season-models/season-field-plant-spread-model';
import { SeasonFarmFieldModel } from '../models/season-farm-field-model';
import { SeasonFieldPlantModel } from '../models/season-models/season-field-plant-model';
import { SeasonDetailFieldModel } from '../models/season-models/season-detail-field-model';

@Injectable({
  providedIn: 'root'
})
export class SeasonSharedDataService {

  //ID's
  private seasonIdSubject = new BehaviorSubject<number | null>(null);
  seasonIdData$ = this.seasonIdSubject.asObservable();

  private fieldIdSubject = new BehaviorSubject<number | null>(null);
  fieldIdData$ = this.fieldIdSubject.asObservable();

  private detailIdSubject = new BehaviorSubject<number | null>(null);
  detailIdData$ = this.detailIdSubject.asObservable();

  private fieldTypeIdSubject = new BehaviorSubject<number | null>(null);
  fieldTypeIdData$ = this.fieldTypeIdSubject.asObservable();

  private farmIdSubject = new BehaviorSubject<number | null>(null);
  farmIdData$ = this.farmIdSubject.asObservable();
 ///////////


  private combinedDataSubject = new BehaviorSubject<SeasonMetaDataCombinedModel | null>(null);
  combinedData$ = this.combinedDataSubject.asObservable();

  private seasonFarmsDataSubject = new BehaviorSubject<SeasonFarmsModel[] | null>(null);
  seasonFarmsData$ = this.seasonFarmsDataSubject.asObservable();

  private seasonFieldsDataSubject = new BehaviorSubject<SeasonFieldsModel[] | null>(null);
  seasonFieldsData$ = this.seasonFieldsDataSubject.asObservable();

  private typeDataSubject = new BehaviorSubject<SeasonTypeModel[] | null>(null);
  typeData$ = this.typeDataSubject.asObservable();

  private cropDataSubject = new BehaviorSubject<SeasonCropModel[] | null>(null);
  cropData$ = this.cropDataSubject.asObservable();

  private irrigationTypeDataSubject = new BehaviorSubject<SeasonIrrigationTypeModel[] | null>(null);
  irrigationTypeData$ = this.irrigationTypeDataSubject.asObservable();

  private tillageDataSubject = new BehaviorSubject<SeasonTillageModel[] | null>(null);
  tillageData$ = this.tillageDataSubject.asObservable();


  private podEffectivenessDataSubject = new BehaviorSubject<SeasonPodEffectivenessModel[] | null>(null);
  podEffectivenessData$ = this.podEffectivenessDataSubject.asObservable();

  private harvestResiduesDataSubject = new BehaviorSubject<SeasonHarvestResiduesModel[] | null>(null);
  harvestResiduesData$ = this.harvestResiduesDataSubject.asObservable();


  private plantActionDataSubject = new BehaviorSubject<SeasonPlantActionModel[] | null>(null);
  plantActionData$ = this.plantActionDataSubject.asObservable();

  private fertilizerPlacementDataSubject = new BehaviorSubject<SeasonFertilizerPlacementModel[] | null>(null);
  fertilizerPlacementData$ = this.fertilizerPlacementDataSubject.asObservable();


  private plantFertilizerTypeDataSubject = new BehaviorSubject<SeasonPlantFertilizerTypeModel[] | null>(null);
  plantFertilizerTypeData$ = this.plantFertilizerTypeDataSubject.asObservable();

  private topDressingMethodDataSubject = new BehaviorSubject<SeasonTopDressingMethodModel[] | null>(null);
  topDressingMethodData$ = this.topDressingMethodDataSubject.asObservable();


  private seasonFieldPlantDataSubject = new BehaviorSubject<SeasonFieldPlantModel[] | null>(null);
  seasonFieldPlantData$ = this.seasonFieldPlantDataSubject.asObservable();


  private typeOfFertilizerBobDataSubject = new BehaviorSubject<SeasonTypeOfFertilizerBobModel[] | null>(null);
  typeOfFertilizerBobData$ = this.typeOfFertilizerBobDataSubject.asObservable();

  private fertilizerTypeDataSubject = new BehaviorSubject<SeasonFertilizerTypeModel[] | null>(null);
  fertilizerTypeData$ = this.fertilizerTypeDataSubject.asObservable();


  private fertilizerPlacementWithPlantingDataSubject = new BehaviorSubject<SeasonFertilizerPlacementWithPlantingModel[] | null>(null);
  fertilizerPlacementWithPlantingData$ = this.fertilizerPlacementWithPlantingDataSubject.asObservable();

  private methodOfTopDressingDataSubject = new BehaviorSubject<SeasonMethodOfTopDressingModel[] | null>(null);
  methodOfTopDressingData$ = this.methodOfTopDressingDataSubject.asObservable();


  private typeOfTopDressingFertilizerDataSubject = new BehaviorSubject<SeasonTypeOfTopDressingFertilizer[] | null>(null);
  typeOfTopDressingFertilizerData$ = this.typeOfTopDressingFertilizerDataSubject.asObservable();


  private waterQualityEcDataSubject = new BehaviorSubject<SeasonWaterQualityEcModel[] | null>(null);
  waterQualityEcData$ = this.waterQualityEcDataSubject.asObservable();

  private seasonStatusDataSubject = new BehaviorSubject<SeasonsStatusModel[] | null>(null);
  seasonStatusData$ = this.seasonStatusDataSubject.asObservable();

  private seasonInputformDataSubject = new BehaviorSubject<any[]>([]);
  seasonInputFormData$ = this.seasonInputformDataSubject.asObservable();

  private formDataSubject = new BehaviorSubject<any[]>([]);
  formData$ = this.formDataSubject.asObservable();

  private _collectedData = new BehaviorSubject<any[]>([]);
  collectedData$ = this._collectedData.asObservable();



  private seasonInputformArrayDataSubject = new BehaviorSubject<SeasonDetailFieldModel[]>([]);
  seasonInputFormArrayData$ = this.seasonInputformArrayDataSubject.asObservable();

  private plantSpreadDataSubject = new BehaviorSubject<any[]>([]);
  plantSpreadData$ = this.plantSpreadDataSubject.asObservable();

  private seasonFarmFieldsDataSubject = new BehaviorSubject<any[]>([]);
  seasonFarmFieldsData$ = this.seasonFarmFieldsDataSubject.asObservable();

  private seasonFieldDataSubject = new BehaviorSubject<any>(null);
  seasonFieldData$ = this.seasonFieldDataSubject.asObservable();

  private isDisabledDataSubject = new BehaviorSubject<any>(null);
  isDisabledData$ = this.isDisabledDataSubject.asObservable();


  private fieldNameDataSubject = new BehaviorSubject<any>(null);
  fieldNameData$ = this.fieldNameDataSubject.asObservable();

  private allowNotificationSubject = new BehaviorSubject<any>(null);
  allowNotificationData$ = this.allowNotificationSubject.asObservable();
  
  private allowBulkNotificationSubject = new BehaviorSubject<any>(null);
  allowBulkNotificationData$ = this.allowBulkNotificationSubject.asObservable();

  


  //DETAIL
  private seasonDetailBaseDataSubject = new BehaviorSubject<any>(null);
  seasonDetailBaseData$ = this.seasonDetailBaseDataSubject.asObservable();

  private seasonDetailExtraDataSubject = new BehaviorSubject<any>(null);
  seasonDetailExstraData$ = this.seasonDetailExtraDataSubject.asObservable();


  private seasonExtraDetailsDataSubject = new BehaviorSubject<any[]>([]);
  seasonExstraDetailsData$ = this.seasonExtraDetailsDataSubject.asObservable();


  private isSaveBtnVisibleDataSubject = new BehaviorSubject<any>(null);
  isSaveBtnVisibleData$ = this.isSaveBtnVisibleDataSubject.asObservable();

  /**
   * True while the open field's cultivar size exceeds its field total. The SAVE
   * button lives in the parent season component, so the flag is published here
   * rather than passed through inputs.
   */
  private cultivarSizeInvalidSubject = new BehaviorSubject<boolean>(false);
  cultivarSizeInvalid$ = this.cultivarSizeInvalidSubject.asObservable();

  setCultivarSizeInvalid(data: boolean) {
    this.cultivarSizeInvalidSubject.next(!!data);
  }
  

  private isHiddenDataSubject = new BehaviorSubject<any>(null);
  isHiddenData$ = this.isHiddenDataSubject.asObservable();

  constructor() { }

  updateCombinedData(data: SeasonMetaDataCombinedModel) {
 
    this.combinedDataSubject.next(data);

    this.typeDataSubject.next(data.seasonFieldType);
    this.cropDataSubject.next(data.seasonFieldCrop);
    this.irrigationTypeDataSubject.next(data.seasonFieldIrrigationType);
    this.tillageDataSubject.next(data.seasonFieldTillage);
    this.podEffectivenessDataSubject.next(data.seasonFieldPodEffectiveness);
    this.harvestResiduesDataSubject.next(data.seasonFieldHarvestResidues);
    this.plantActionDataSubject.next(data.seasonFieldPlantAction);
    this.fertilizerPlacementDataSubject.next(data.seasonFieldFertilizerPlacement);
    this.plantFertilizerTypeDataSubject.next(data.seasonFieldPlantFertilizerType);
    this.topDressingMethodDataSubject.next(data.seasonFieldTopDressingMethod);
    this.typeOfFertilizerBobDataSubject.next(data.seasonFieldTypeOfFertilizerBob);
    this.fertilizerTypeDataSubject.next(data.seasonFieldFertilizerType);
    this.fertilizerPlacementWithPlantingDataSubject.next(data.seasonFieldFertilizerPlacementWithPlanting);
    this.methodOfTopDressingDataSubject.next(data.seasonFieldMethodOfTopDressing);
    this.typeOfTopDressingFertilizerDataSubject.next(data.seasonFieldTypeOfTopDressingFertilizer);
    this.waterQualityEcDataSubject.next(data.seasonFieldWaterQualityEc);
    this.seasonStatusDataSubject.next(data.seasonsStatus);
    // this.plantSpreadDataSubject.next(data.seasonFieldPlantSpread);
    this.plantSpreadDataSubject.next(data.seasonFieldPlant);
  }



  // ID's NEEDED TO BE ADDED HERE

  //SEASON
  updateSeasonId(data: number) {
    this.seasonIdSubject.next(data);
  }

  //FIELD
  updateFieldId(data: number) {
    this.fieldIdSubject.next(data);
  }

  //Detail
  updateDetailId(data: number) {
    this.detailIdSubject.next(data);
  }

  //FFIELD TYPE
  updateFieldTypeId(data: number) {
    this.fieldTypeIdSubject.next(data);
  }

  //FARM ID
  updateFarmId(data: number) {
    this.farmIdSubject.next(data);
  }

  //FIELD NAME 
  updateFieldName(data: string) {
    this.fieldNameDataSubject.next(data);
  }

  updateAllowNotification(data: boolean) {
    this.allowNotificationSubject.next(data);
  }

  updateBulkAllowNotification(checked: boolean, farmIndex: number) {
    let data = {
      checked: checked,
      farmIndex: farmIndex
    }
    this.allowBulkNotificationSubject.next(data);
  }

  
  updateSeasonFarms(data: SeasonFarmsModel[]) {
    this.seasonFarmsDataSubject.next(data);
  }

  // updateSelectedFarmFields(data: SeasonFarmsModel[]){
  //   this.seasonFarmsDataSubject.next(data);
  // }

  updateSeasonFields(data: SeasonFieldsModel[]) {
    this.seasonFieldsDataSubject.next(data);
  }


  // EMITTED DETAIL
  updateFormData(newData: any[]) {
    this.seasonInputformDataSubject.next(newData);
  }

  
  addData(data: any): void {
    this._collectedData.next([data]);
  }


    // // EMITTED DETAIL FORM DATA BASE + EXTRA
    // addData(data: any): void {
    //   const currentValue = this._collectedData.getValue();
    //   this._collectedData.next([...currentValue, data]);
    // }


  // EMITTED DETAIL FORM DATA BASE + EXTRA
  updateFormArrayData(formArrayData: SeasonDetailFieldModel[]) {
    this.seasonInputformArrayDataSubject.next(formArrayData);
  }


  // EMITTED DETAIL FORM DATA BASE + EXTRA
  resetData(): void {
    this._collectedData.next([]);
  }



  updateIsDisabledData(isDisable: boolean) {
    this.isDisabledDataSubject.next(isDisable);
  }


  //DETAIL
  updateSeasonDetailBaseData(data: any) {
    this.seasonDetailBaseDataSubject.next(data);
  }

  updateSeasonDetailExtraData(data: any) {
    this.seasonDetailExtraDataSubject.next(data);
  }


  updateSeasonExtraDetailsData(data: any[]) {
    this.seasonExtraDetailsDataSubject.next(data);
  }

  

  //GET FARMS & FIELDS
  updateSeasonFarmFieldsData(data: SeasonFarmFieldModel[]) {
    this.seasonFarmFieldsDataSubject.next(data);
  }

  //GET FIELDS
  updateSeasonFieldData(data: SeasonFieldsModel[]) {
    this.seasonFieldDataSubject.next(data);
  }

//SHOW SAVE BUTTON
  updateIsSaveBtnVisibleDataSubjectData(data: boolean) {
    this.isSaveBtnVisibleDataSubject.next(data);
  }

  updateIsHiddenData(data: boolean) {
    this.isHiddenDataSubject.next(data);
  }
  
  

//SAVE MULTI
  updateMultiFormData(newData: any[]) {
    this.formDataSubject.next(newData);
  }



  ////////////// GET /////////////
  getMultiFormData(): any[] {
    return this.formDataSubject.getValue();
  }

  //ID's
  getSeasonIdData(): number | null {
    return this.seasonIdSubject.getValue();
  }

  getFieldIdData(): number | null {
    return this.fieldIdSubject.getValue();
  }

  getDetailIdData(): number | null {
    return this.detailIdSubject.getValue();
  }

  getFieldTypeIdData(): number | null {
    return this.fieldTypeIdSubject.getValue();
  }

  getFarmIdData(): number | null {
    return this.farmIdSubject.getValue();
  }

  //////////

  getSeasonFarms(): SeasonFarmsModel[] | null {
    return this.seasonFarmsDataSubject.getValue();
  }

  getSeasonFields(): SeasonFieldsModel[] | null {
    return this.seasonFieldsDataSubject.getValue();
  }

  getCombinedData(): SeasonMetaDataCombinedModel | null {
    return this.combinedDataSubject.getValue();
  }

  getTypedData(): SeasonTypeModel[] | null {
    return this.typeDataSubject.getValue();
  }


  getCropData(): SeasonCropModel[] | null {
    return this.cropDataSubject.getValue();
  }


  getIrrigationTypeData(): SeasonIrrigationTypeModel[] | null {
    return this.irrigationTypeDataSubject.getValue();
  }


  getTillageData(): SeasonPodEffectivenessModel[] | null {
    return this.tillageDataSubject.getValue();
  }


  getPodEffectivenessData(): SeasonPodEffectivenessModel[] | null {
    return this.podEffectivenessDataSubject.getValue();
  }


  getharvestResiduesData(): SeasonHarvestResiduesModel[] | null {
    return this.harvestResiduesDataSubject.getValue();
  }


  getPlantActionData(): SeasonPlantActionModel[] | null {
    return this.plantActionDataSubject.getValue();
  }


  getFertilizerPlacementData(): SeasonFertilizerPlacementModel[] | null {
    return this.fertilizerPlacementDataSubject.getValue();
  }


  getPlantFertilizerTypeData(): SeasonPlantFertilizerTypeModel[] | null {
    return this.plantFertilizerTypeDataSubject.getValue();
  }


  getTopDressingMethodData(): SeasonTopDressingMethodModel[] | null {
    return this.topDressingMethodDataSubject.getValue();
  }


  getTypeOfFertilizerBobData(): SeasonTypeOfFertilizerBobModel[] | null {
    return this.typeOfFertilizerBobDataSubject.getValue();
  }


  getFertilizerTypeData(): SeasonFertilizerTypeModel[] | null {
    return this.fertilizerTypeDataSubject.getValue();
  }


  getFertilizerPlacementWithPlantingData(): SeasonFertilizerPlacementWithPlantingModel[] | null {
    return this.fertilizerPlacementWithPlantingDataSubject.getValue();
  }


  getMethodOfTopDressingData(): SeasonMethodOfTopDressingModel[] | null {
    return this.methodOfTopDressingDataSubject.getValue();
  }


  getTypeOfTopDressingFertilizerdData(): SeasonTypeOfTopDressingFertilizer[] | null {
    return this.typeOfTopDressingFertilizerDataSubject.getValue();
  }

  getWaterQualityEcData(): SeasonWaterQualityEcModel[] | null {
    return this.waterQualityEcDataSubject.getValue();
  }

  getSeasonStatusData(): SeasonsStatusModel[] | null {
    return this.seasonStatusDataSubject.getValue();
  }

  getSeasonPlantSpreadData(): SeasonFieldPlantSpreadModel[] | null {
    return this.plantSpreadDataSubject.getValue();
  }

  getSeasonFieldPlantData(): SeasonFieldPlantModel[] | null {
    return this.seasonFieldPlantDataSubject.getValue();
  }



  getSeasonFarmFieldsDataData(): SeasonFieldsModel[] | null {
    return this.seasonFarmFieldsDataSubject.getValue();
  }

  getSeasonFieldDataData(): SeasonFieldsModel | null {
    return this.seasonFieldDataSubject.getValue();
  }

  getIsDisableData(): boolean | false {
    return this.isDisabledDataSubject.getValue();
  }


  //DETAIL
  getSeasonDetailBaseData(): any | null {
    return this.seasonDetailBaseDataSubject.getValue();
  }

  getSeasonDetailExstraData(): any | null {
    return this.seasonDetailExtraDataSubject.getValue();
  }

  getSeasonExtraDetailsData(): any[] | [] {
    return this.seasonExtraDetailsDataSubject.getValue();
  }

  getSeasonFieldNameData(): any | null {
    return this.fieldNameDataSubject.getValue();
  }

  getSeasonAllowNotificationData(): boolean | null {
    return this.allowNotificationSubject.getValue();
  }

  getSeasonBulkAllowNotificationData(): boolean | null {
    return this.allowBulkNotificationSubject.getValue();
  }

  getIsSaveBtnVisibleDataSubjectData(): boolean | null {
    return this.isSaveBtnVisibleDataSubject.getValue();
  }

  getIsHiddenData(): boolean | null {
    return this.isHiddenDataSubject.getValue();
  }

  


//GET BASE & EXTRA EMITTED DATA
  getSeasonDetailBaseAndExstraData(): any | null {
    return this.seasonInputformArrayDataSubject.getValue();
  }


    // EMIT DATA
  getSeasonDetailData(): SeasonDetailFieldModel[] | null {
    return this.seasonInputformDataSubject.getValue();
  }

  
  ////////////// SET /////////////


  //ID's

  // EMIT DATA
  setSeasonData(data: any[]) {
    return this.seasonInputformDataSubject.next(data);
  }

  setSeasonIdData(data: number) {
    return this.seasonIdSubject.next(data);
  }

  setFieldIdData(data: number) {
    return this.fieldIdSubject.next(data);
  }

  setDetailIdData(data: number) {
    return this.detailIdSubject.next(data);
  }

  setFieldTypeIdData(data: number) {
    return this.fieldTypeIdSubject.next(data);
  }

  setFarmIdData(data: number) {
    return this.farmIdSubject.next(data);
  }

  ///////

  setFarmsData(data: SeasonFarmsModel[]) {
    return this.seasonFarmsDataSubject.next(data);
  }

  setFieldsData(data: SeasonFieldsModel[]) {
    return this.seasonFieldsDataSubject.next(data);
  }


  setTypedData(data: SeasonTypeModel[]) {
    return this.typeDataSubject.next(data);
  }


  setCropData(data: SeasonCropModel[]) {
    return this.cropDataSubject.next(data);
  }


  setIrrigationTypeData(data: SeasonIrrigationTypeModel[]) {
    return this.irrigationTypeDataSubject.next(data);
  }


  setTillageData(data: SeasonPodEffectivenessModel[]) {
    return this.tillageDataSubject.next(data);
  }


  setPodEffectivenessData(data: SeasonPodEffectivenessModel[]) {
    return this.podEffectivenessDataSubject.next(data);
  }


  setharvestResiduesData(data: SeasonHarvestResiduesModel[]) {
    return this.harvestResiduesDataSubject.next(data);
  }


  setPlantActionData(data: SeasonPlantActionModel[]) {
    return this.plantActionDataSubject.next(data);
  }


  setFertilizerPlacementData(data: SeasonFertilizerPlacementModel[]) {
    return this.fertilizerPlacementDataSubject.next(data);
  }


  setPlantFertilizerTypeData(data: SeasonPlantFertilizerTypeModel[]) {
    return this.plantFertilizerTypeDataSubject.next(data);
  }


  setTopDressingMethodData(data: SeasonTopDressingMethodModel[]) {
    return this.topDressingMethodDataSubject.next(data);
  }


  setTypeOfFertilizerBobData(data: SeasonTypeOfFertilizerBobModel[]) {
    return this.typeOfFertilizerBobDataSubject.next(data);
  }


  setFertilizerTypeData(data: SeasonFertilizerTypeModel[]) {
    return this.fertilizerTypeDataSubject.next(data);
  }


  setFertilizerPlacementWithPlantingData(data: SeasonFertilizerPlacementWithPlantingModel[]) {
    return this.fertilizerPlacementWithPlantingDataSubject.next(data);
  }


  setMethodOfTopDressingData(data: SeasonMethodOfTopDressingModel[]) {
    return this.methodOfTopDressingDataSubject.next(data);
  }


  setTypeOfTopDressingFertilizerdData(data: SeasonTypeOfTopDressingFertilizer[]) {
    return this.typeOfTopDressingFertilizerDataSubject.next(data);
  }

  setWaterQualityEcData(data: SeasonWaterQualityEcModel[]) {
    return this.waterQualityEcDataSubject.next(data);
  }

  setSeasonStatusData(data: SeasonsStatusModel[]) {
    return this.seasonStatusDataSubject.next(data);
  }

  setSeasonPlantSpreadData(data: SeasonFieldPlantSpreadModel[]) {
    return this.plantSpreadDataSubject.next(data);
  }

  setSeasonFieldPlantData(data: SeasonFieldPlantModel[]) {
    return this.seasonFieldPlantDataSubject.next(data);
  }



  setSeasonFarmFieldsDataData(data: SeasonFieldPlantSpreadModel[]) {
    return this.seasonFarmFieldsDataSubject.next(data);
  }

  setSeasonFieldDataData(data: SeasonFieldPlantSpreadModel[]) {
    return this.seasonFieldDataSubject.next(data);
  }

  setIsDisabledData(data: boolean) {
    return this.isDisabledDataSubject.next(data);
  }


  //DETAIL
  setSeasonDetailBaseData(data: any) {
    return this.seasonDetailBaseDataSubject.next(data);
  }

  setSeasonDetailExtraData(data: any) {
    return this.seasonDetailExtraDataSubject.next(data);
  }

  setSeasonFieldNameData(data: any) {
    return this.fieldNameDataSubject.next(data);
  }

  setIsSaveBtnVisibleDataSubjectData(data: any) {
    return this.isSaveBtnVisibleDataSubject.next(data);
  }

  // Cost save trigger
  private saveCostsTriggerSubject = new BehaviorSubject<boolean>(false);
  saveCostsTrigger$ = this.saveCostsTriggerSubject.asObservable();

  triggerSaveCosts(): void {
    this.saveCostsTriggerSubject.next(true);
    // Reset immediately so late subscribers don't re-fire
    setTimeout(() => this.saveCostsTriggerSubject.next(false), 0);
  }
  
  
}

